import { useAppDispatch } from "hooks/hooks";
import {
  getProjectsList,
  selectState,
  setNewProjectPopoverOpen,
  setSearchProjectsPopoverOpen,
  updateField,
} from "../main.slice";
import { useSelector } from "react-redux";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { useNavigate } from "react-router-dom";
import Popover from "components/Popover/Popover";
import NewProjectPopover from "./NewProjectPopover";
import SearchProjectsPopover from "./SearchProjectsPopover";
import { ICreateProjectRequestParams } from "Dashboard/scenes/Projects/domain/ICreateProjectRequestParams";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { IOption } from "Dashboard/domain/IOption";
import { IGetProjectsListRequestParams } from "Dashboard/scenes/Projects/domain/IGetProjectsListRequestParams";
import { SearchType } from "Dashboard/domain/SearchType";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PROJECT_MODULE_NAME } from "Dashboard/scenes/Projects/domain/ProjectModule";
import { areQueryParamsEmpty } from "utils/queryParamsUtil";

const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    newProjectPopoverOpen,
    searchProjectsPopoverOpen,
    newProjectFormData,
    permission
  } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  const {
    handleSubmit,
    register,
    control,
    clearErrors,
    reset,
    formState: { errors },
    getValues,
    setFocus,
  } = useForm<ICreateProjectRequestParams>({
    defaultValues: newProjectFormData
  });
  const [clientPartnerValue, setClientPartnerValue] = useState<IOption | undefined>(undefined);
  const [municipalityValue, setMunicipalityValue] = useState<IOption | undefined>(undefined);

  const onClosePopover = () => {
    const values = getValues();
    for (const field in values) {
      dispatch(updateField({
        field: field as keyof ICreateProjectRequestParams,
        value: values[field as keyof ICreateProjectRequestParams]
      }));
    }
  };

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    setFocus: setFocusSearch,
    getValues: getValuesSearch,
    setValue: setValueSearch
  } = useForm<IGetProjectsListRequestParams>();
  const [searchType, setSearchType] = useState<SearchType>(SearchType.BASIC);

  const isSearchFormEmpty = areQueryParamsEmpty(getValuesSearch());

  return (
    <>
      <nav className="container">
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            tooltip="Glavni meni"
            toolbox={true}
            onClick={() => navigate('/dashboard')}
          />
        </div>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Add}
            tooltip="Novi"
            toolbox={true}
            onClick={hasWriteAccessTo(user, PROJECT_MODULE_NAME)
              ? () => {
                dispatch(setNewProjectPopoverOpen({ isOpen: true }));
              }
              : undefined}
          />
          <ToolboxButton
            icon={ToolboxButtonIcon.Search}
            tooltip="Traži"
            toolbox={true}
            onClick={() => {
              dispatch(setSearchProjectsPopoverOpen({ isOpen: true }));
            }}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => {
                dispatch(getProjectsList({ permission }));
                resetSearch();
              }}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            toolbox={true}
          />
        </div>
      </nav>
      <Popover
        isOpen={newProjectPopoverOpen.isOpen}
        onClose={() => {
          onClosePopover();
          dispatch(setNewProjectPopoverOpen({ isOpen: false }));
        }}
        title="Dodaj projekat"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 190 }}
      >
        <NewProjectPopover
          handleSubmit={handleSubmit}
          register={register}
          getValues={getValues}
          control={control}
          clearErrors={clearErrors}
          reset={reset}
          errors={errors}
          setFocus={setFocus}
          clientPartnerValue={clientPartnerValue}
          setClientPartnerValue={setClientPartnerValue}
          municipalityValue={municipalityValue}
          setMunicipalityValue={setMunicipalityValue}
        />
      </Popover>
      <Popover
        isOpen={searchProjectsPopoverOpen.isOpen}
        onClose={() => dispatch(setSearchProjectsPopoverOpen({ isOpen: false }))}
        title="Pretraga"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 250 }}
      >
        <SearchProjectsPopover
          handleSubmit={handleSubmitSearch}
          register={registerSearch}
          control={controlSearch}
          reset={resetSearch}
          setFocus={setFocusSearch}
          searchType={searchType}
          setSearchType={setSearchType}
          getValues={getValuesSearch}
          setValue={setValueSearch}
        />
      </Popover>
    </>
  );
};

export default Toolbox;
